"use client";
import React, { Suspense } from "react";
import { VStack, Heading, Divider } from "@chakra-ui/react";
import Tabs from "@/components/tabs";
import { useSectionHeadingVariant } from "@/theme/components/useSectionHeading";
import { tablist } from "./pricingTabsList";
import PricingFooter from "./tableFooter";

const ID = "cloud-services-tab";

const PricingTabs = () => {
  const headingVariant = useSectionHeadingVariant();
  return (
    <VStack id={ID} spacing={4}>
      <Heading as="h1" variant={headingVariant}>
        Shared Resources Pricing
      </Heading>
      <Suspense>
        <Tabs columns={{ base: 1, sm: 2 }} tabList={tablist} />
      </Suspense>
      <PricingFooter />
      <Divider mt={8} />
    </VStack>
  );
};

export default PricingTabs;
